var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtiqxIdLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "196px",
    height: "47px",
    viewBox: "0 0 196 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-5",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(106.312280, 6.006644)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 4.25249119
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21.5282366,
    y1: 0.15946842,
    x2: 0.10631228,
    y2: 28.3853787,
    id: "Line-7-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.5282366,
    y1: 0.15946842,
    x2: 0.10631228,
    y2: 28.3853787,
    id: "Line-7-Copy-9",
    transform: "translate(10.843853, 14.245845) scale(-1, 1) translate(-10.843853, -14.245845) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q",
    transform: "translate(62.458955, 0.159959)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 4.25249119
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1993331,34.4451786 C24.1332147,34.4451786 27.6946761,32.850658 30.2726671,30.2726671 C32.850658,27.6946761 34.4451786,24.1332147 34.4451786,20.1993331 C34.4451786,12.3315699 28.0670963,5.95348766 20.1993331,5.95348766 C12.3315699,5.95348766 5.95348766,12.3315699 5.95348766,20.1993331 C5.95348766,24.1332147 7.54800823,27.6946761 10.1259992,30.2726671",
    id: "Oval",
    transform: "translate(20.199333, 20.199333) rotate(-45.000000) translate(-20.199333, -20.199333) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.7009927,
    y1: 34.3388663,
    x2: 25.6212594,
    y2: 26.2591331,
    id: "Line-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I",
    transform: "translate(58.737535, 5.886112)",
    stroke: "#FFFFFF",
    strokeWidth: 4.25249119
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.212624559,
    y1: 0.279999847,
    x2: 0.10631228,
    y2: 28.6653785,
    id: "Line-7-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.3726136,
    y1: 0.279999847,
    x2: 92.2663013,
    y2: 28.6653785,
    id: "Line-7-Copy-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.822446,0.257886893 L110.222445,0.257886893 C117.291689,0.257886893 123.022444,5.98864141 123.022444,13.0578854 L123.022444,15.873885 C123.022444,22.943129 117.291689,28.6738835 110.222445,28.6738835 L103.822446,28.6738835 L103.822446,28.6738835 L103.822446,0.257886893 Z",
    id: "Rectangle",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I-Copy",
    transform: "translate(136.817525, 31.766109)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.06245823,
    cy: 2.79388671,
    r: 1.91999977
  })), /*#__PURE__*/React.createElement("g", {
    id: "T",
    transform: "translate(27.045044, 5.953488)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 4.25249119
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.117743708,
    y1: 0.10631228,
    x2: 21.7825859,
    y2: 0.10631228,
    id: "Line-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.9615962,
    y1: 2.25280783,
    x2: 10.9615962,
    y2: 28.5777533,
    id: "Line-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "A",
    transform: "translate(0.000000, 6.006644)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 4.25249119
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11.9601315,
    y1: 0.15946842,
    x2: 0.10631228,
    y2: 28.3853787,
    id: "Line-7-Copy-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-7-Copy-6",
    transform: "translate(17.940197, 14.272424) scale(-1, 1) translate(-17.940197, -14.272424) ",
    points: "23.9202629 0.15946842 17.8870411 14.2724235 11.9601315 28.3853787"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.42935669,
    y1: 19.1893665,
    x2: 18.6806679,
    y2: 19.1893665,
    id: "Line-6-Copy"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtiqxIdLogoWhite);
export default __webpack_public_path__ + "static/media/atiqx_id_logo_white.cc5178ac332001b5ed68526176f4e5ac.svg";
export { ForwardRef as ReactComponent };